import { useMemo } from "react";

function useRequirePermission(Permission, type) {
  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

  const isAccessible = useMemo(() => {
    const typeOk = type ? type.includes(loggedInUser?.type) : true;
    const permOk = Permission
      ? Array.isArray(loggedInUser?.permissions) &&
        loggedInUser.permissions.some((userPermission) => Permission.includes(userPermission))
      : true;
    return typeOk && permOk;
  }, []);

  return isAccessible;
}

export default useRequirePermission;
